/**
 * Initialize tokens from environment variables
 * Call this function at app startup (in main.js after store import)
 */
import store from '@/store/store';

export function initializeTokens() {
    // Initialize tokens from environment variables if they exist
    if (process.env.VUE_APP_INTERNAL_COMMISSION_TOKEN) {
        store.commit('setCommissionToken', process.env.VUE_APP_INTERNAL_COMMISSION_TOKEN);
    }
    
    if (process.env.VUE_APP_NUERA_PROTECTED_API_TOKEN) {
        store.commit('setInternalToken', process.env.VUE_APP_NUERA_PROTECTED_API_TOKEN);
    }
    
    if (process.env.VUE_APP_INTERNAL_PAYMENT_TOKEN) {
        store.commit('setPaymentToken', process.env.VUE_APP_INTERNAL_PAYMENT_TOKEN);
    }
    
    if (process.env.VUE_APP_MESSAGE_CENTRE_INTERNAL_TOKEN) {
        store.commit('setMsgCenterToken', process.env.VUE_APP_MESSAGE_CENTRE_INTERNAL_TOKEN);
    }
    
    if (process.env.VUE_APP_INTERNAL_TICKETING_TOKEN) {
        store.commit('setTicketingToken', process.env.VUE_APP_INTERNAL_TICKETING_TOKEN);
    }
}
